import type { ComponentChildren } from "preact";
import { Navbar } from "./Navbar";
import "./Layout.css";

type LayoutProps = {
  children: ComponentChildren;
};

export function Layout({ children }: LayoutProps) {
  return (
    <div class="layout">
      <Navbar />
      <main class="layout__main">
        <div class="layout__container">{children}</div>
      </main>
    </div>
  );
}
